import TabWithContentAPI from './tab-with-content-api';

export default TabWithContentAPI;
